module.exports = __webpack_public_path__ + "media/images/fc-logo-ef5dcabd64b2a4654adc2154c9619028.png";